import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { Colors } from '../../themes/colors';
import { Button } from '../crop-circle/Button';

export type PillToggleOption = {
  value: any;
  label: string;
};

export type PillToggleProps = {
  options: PillToggleOption[];
  value: any;
  setValue: (value: any) => void;
  disabled?: boolean;
  useCropCircle?: boolean;
};

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
const PillToggleOld = (props: PillToggleProps) => {
  const onPress = (option: PillToggleOption) => {
    const selected = props.options.filter((o) => o === option)[0];
    props.setValue(selected.value);
  };

  return (
    <View style={styles.container}>
      {props.options.map((option) => (
        <TouchableOpacity
          key={option.value}
          style={[
            styles.option,
            props.value === option.value && styles.selected,
          ]}
          onPress={() => onPress(option)}
          disabled={props.disabled}
        >
          <Text
            style={
              props.value === option.value ? styles.selectedText : styles.text
            }
          >
            {option.label}
          </Text>
        </TouchableOpacity>
      ))}
    </View>
  );
};

// TODO: Crop Circle Redesign | Remove to PillToggleBase after feature is fully rolled out
const PillToggleBase = (props: PillToggleProps) => {
  const onPress = (option: PillToggleOption) => {
    const selected = props.options.filter((o) => o === option)[0];
    props.setValue(selected.value);
  };

  return (
    <View style={stylesCropCircle.container}>
      {props.options.map((option) => (
        <Button
          key={option.value}
          state={props.value === option.value ? 'active' : 'default'}
          onPress={() => onPress(option)}
          disabled={props.disabled}
          variant="rectangular"
          size="large"
          style={stylesCropCircle.option}
        >
          {option.label}
        </Button>
      ))}
    </View>
  );
};

export const PillToggle = (props: PillToggleProps) => {
  if (props.useCropCircle) {
    return <PillToggleBase {...props} />;
  }

  return <PillToggleOld {...props} />;
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginVertical: 10,
    borderRadius: 25,
    overflow: 'hidden',
    padding: 1,
    gap: 18,
  },
  option: {
    flex: 1,
    borderRadius: 25,
    paddingVertical: 15,
    paddingHorizontal: 20,
    backgroundColor: Colors.white,
    borderColor: Colors.info,
    borderWidth: 1,
  },
  selected: {
    backgroundColor: '#007BFF',
  },
  text: {
    color: Colors.info,
    textAlign: 'center',
    fontWeight: '500',
    fontSize: 16,
  },
  selectedText: {
    color: Colors.white,
    textAlign: 'center',
    fontWeight: '500',
    fontSize: 16,
  },
});

const stylesCropCircle = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 10,
    gap: 8,
  },
  option: {
    flex: 1,
  },
});
